<template>
  <template v-if="isShown">
    <template v-if="isFilterFull">
      <VClientFilter />
      <div
        v-if="screenWidth !== 'mobile'"
        class="arrow"
        @click="$store.commit({ type: 'setIsFilterFull', value: false })"
      >
        <FilterArrowIcon />
      </div>
    </template>

    <div v-else class="filter-short">
      <div>
        <div class="filter-short-input">
          <SearchableInput
            class="input"
            :value="filters.searchQuery"
            :items="initItems"
            is-map-catering
            @update="filterOnlyByName($event)"
          />
          <VButton
            v-if="isChangedFilterSaved"
            @click="onArrowClickHandler"
            class="button"
          >
            <template #leftAddon>
              <FilterMapIcon color="#FFFFFF" />
            </template>
            <template #default>Изменить фильтры</template>
          </VButton>
        </div>
      </div>
      <div class="filter-short-arrow-wrapper">
        <div
          class="filter-short-arrow"
          :style="{ display: 'flex', alignItems: 'center' }"
          @click="onArrowClickHandler"
        >
          <FilterArrowIcon />
        </div>
      </div>
    </div>
  </template>

  <FilterRestaurantsForBooking />

  <VMap :items="filteredItems" :center="centerCoords" />
  <div
    v-if="screenWidth === 'mobile' && !isAuthPage && !isCollapsed"
    class="mobile-items"
  >
    <div class="login-mobile" @click="onProfileClickHandler">
      <IconPerson color="#222" />
    </div>

    <div v-if="isAuth" class="ring-btn" @click="$store.commit('toggleNotices')">
      <IconRing />
      <div class="ring_hasItems" v-if="unreadItems">
        <span v-if="unreadItems < 10">{{ unreadItems }}</span>
      </div>
    </div>
  </div>

  <div
    v-if="screenWidth === 'mobile'"
    class="city-btn"
    @click="onCityClickHandler"
  >
    <CityIcon />
  </div>

  <AuthMobile v-if="isAuthPage" />

  <div
    v-if="
      filteredItems.length === 0 &&
      isLoaded &&
      (isChangedFilterSaved || filters.searchQuery)
    "
    class="empty-alert"
    :class="{ _filled: isFilled }"
  >
    <IconBigWarn />
    <span>
      По вашему запросу заведений не найдено, измените параметры поиска
    </span>
  </div>
</template>

<script>
import VMap from "@/components/pages/home/VMap.vue";
import VClientFilter from "@/components/pages/home/VClientFilter.vue";
import VButton from "@/components/ui/VButton.vue";
import { isProd } from "@/assets/js/utils/helpers";
import SearchableInput from "@/components/ui/SearchableInput.vue";
import FilterArrowIcon from "@/components/icons/FilterArrowIcon.vue";
import IconRing from "@/components/icons/IconRing.vue";
import IconPerson from "@/components/icons/IconPerson.vue";
import AuthMobile from "@/components/pages/home/AuthMobile.vue";
import IconBigWarn from "@/components/icons/IconBigWarn.vue";
import FilterMapIcon from "@/components/icons/FilterMapIcon.vue";
import CityIcon from "@/components/icons/CityIcon.vue";
import ChooseCityModal from "@/components/modals/ChooseCityModal.vue";
import FilterRestaurantsForBooking from "@/components/pages/home/FilterRestaurantsForBooking.vue";
import store from "@/store";

export default {
  name: "MapPage",
  components: {
    FilterRestaurantsForBooking,
    CityIcon,
    FilterMapIcon,
    IconBigWarn,
    AuthMobile,
    IconPerson,
    IconRing,
    FilterArrowIcon,
    SearchableInput,
    VButton,
    VClientFilter,
    VMap,
  },

  data() {
    return {
      modal: "",
      isLoaded: false,
      centerCoords: [56.834463, 60.600582],
    };
  },

  methods: {
    filterOnlyByName(value) {
      this.$store.dispatch("filterOnlyByName", { value });
    },
    onProfileClickHandler() {
      if (this.isAuth) {
        this.$router.push("/account/settings");
      } else {
        this.$store.commit({
          type: "setIsAuthPage",
          value: true,
        });
      }
    },
    onCityClickHandler() {
      this.$store.dispatch("openModal", {
        value: {
          component: ChooseCityModal,
          props: null,
        },
      });
    },
    onArrowClickHandler() {
      if (isProd()) {
        window.ym(99602273, "reachGoal", "filter_button");
      }
      this.$store.commit("setIsFilterFull", { value: true });
    },
  },

  async mounted() {
    if (this.$route.name === "map") {
      this.$store.commit({
        type: "setListScrollbarTop",
        value: 0,
      });
    }
    if (this.screenWidth === "mobile") {
      this.$store.commit("setIsFilterFull", { value: true });
    }

    this.isLoaded = true;
    this.centerCoords = [this.city.latitude, this.city.longitude];
  },

  beforeUnmount() {
    this.$store.commit({ type: "setIsFooter", value: false });
    this.$store.commit({ type: "setMapEditMode", value: "" });
  },

  watch: {
    isChangeAccountModalClosed() {
      this.$store.dispatch("setCities", {
        value: {
          hideRoleCheck: true,
        },
      });
    },
    cities: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.$store.dispatch("setCities");
          });
        }
      },
      deep: true,
      immediate: true,
    },
    city: {
      async handler(val) {
        if (val) {
          this.centerCoords = [val.latitude, val.longitude];
          await this.$store.dispatch("getClientRestaurants", {
            value: { city: val.city, settlement: "" },
          });
          this.items = this.filteredItems;
        }
      },
      deep: true,
    },
    isFilter: {
      handler() {
        this.filter();
      },
    },
  },

  computed: {
    store() {
      return store;
    },
    isChangedFilterSaved() {
      return this.$store.state.clientRestaurants.isChangedFilterSaved;
    },
    filters() {
      return this.$store.state.clientRestaurants.restaurantFilter;
    },
    isChangeAccountModalClosed() {
      return this.$store.state.general.isChangeAccountModalClosed;
    },
    cities() {
      return this.$store.state.general.cities;
    },
    city() {
      return this.$store.state.general.city;
    },
    isFilterFull() {
      return (
        this.$store.state.clientRestaurants.isFilterFull &&
        this.$route.name !== "map/:catId"
      );
    },
    isCollapsed() {
      return this.$store.state.clientRestaurants.isCollapsed;
    },
    unreadItems() {
      return this.$store.state.notices.unreadItems.length;
    },
    isFilter() {
      return this.$store.state.clientRestaurants.isFilter;
    },
    isAuthPage() {
      return this.$store.state.clientRestaurants.isAuthPage;
    },
    isAuth() {
      return this.$store.state.general.auth.isAuth;
    },
    isNotices() {
      return this.$store.state.notices.isNotices;
    },
    isShown() {
      if (this.isMenu) {
        return false;
      }
      if (this.screenWidth !== "mobile") {
        return true;
      } else {
        return !this.clickedCatering;
      }
    },

    isMenu() {
      return this.$store.state.general.isMenu;
    },

    initItems() {
      return this.$store.state.clientRestaurants.items;
    },

    filteredItems() {
      return this.$store.state.clientRestaurants.filteredItems;
    },

    roleGroup() {
      return this.$store.getters.roleGroup;
    },

    clickedCatering() {
      return this.$route.params.catId;
    },

    screenWidth() {
      return this.$store.getters.screenType;
    },

    isFilled() {
      return this.$store.getters.isMapFilterFilled;
    },
  },
};
</script>

<style lang="scss" scoped>
.cross {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  border: 2px solid #858585;
  cursor: pointer;
}

.filter-short {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  z-index: 1111;

  .filter-short-input {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 288px;
    padding: 8px;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0 4px 16px 0 #00000014;

    button {
      width: 100%;
    }
  }

  .filter-short-arrow-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
  }

  .filter-short-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    transform: rotate(180deg);
    background-color: #222222b2;
    cursor: pointer;
  }
}

.mobile-items {
  position: fixed;
  top: 152px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 111111111;
}

.login-mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 -2px 60px 0 #00000026;
  background-color: #fff;
}

.city-btn {
  position: fixed;
  bottom: 96px;
  right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 -2px 60px 0 #00000026;
  background-color: #fff;
  z-index: 111111111;
}

.empty-alert {
  position: absolute;
  left: 782px;
  top: 88px;
  display: flex;
  align-items: center;
  padding: 14px 16px;
  width: 434px;
  height: 52px;
  gap: 8px;
  border-radius: 8px;
  background-color: #fef6e8;
  z-index: 111111111;

  @include l-laptop {
    width: 264px;
    height: auto;
    top: 148px;
    left: auto;
    right: 16px;
    transform: none;
  }

  @include mobile {
    width: calc(100% - 32px);
    height: 94px;
    top: auto;
    left: 16px;
    right: auto;
    bottom: 96px;
  }

  &._filled {
    left: 528px;
    width: 880px;

    @include l-laptop {
      left: auto;
      right: 16px;
      top: 216px;
      width: 426px;
      height: 72px;
    }

    @include mobile {
      width: calc(100% - 32px);
      height: 94px;
      top: auto;
      left: 16px;
      right: auto;
      bottom: 96px;
    }
  }

  svg {
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
  }

  span {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #f0811e;
  }
}

.arrow {
  position: absolute;
  left: 320px;
  top: 24px;
  width: 56px;
  height: 48px;
  transform: rotate(180deg);
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  background-color: #222222b2;
  z-index: 1111;
  cursor: pointer;

  svg {
    transform: rotate(180deg);
    position: absolute;
    top: 8px;
    right: 8px;
  }
}

.ring-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 -2px 60px 0 #00000026;
  background-color: #fff;
  cursor: pointer;
}

.ring_hasItems {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  transform: translate(50%, -50%);
  border-radius: 50%;
  background-color: #f18e35;

  span {
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
}
</style>
